import { StudentConstants as Constants } from '../types'

const initialState = {
    students: [],    
    error: null,    
    total: 0,
    loading: false   
};

export function studentReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:            
            return {
                ...state,
                students: action?.payload?.students,
                total: action?.payload?.total,
                loading: false,
                error: null,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                students: [...state?.students, action?.payload?.student],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.students.findIndex(x => x.id ===  action?.payload?.student?.id)
            const newArray = [...state.students];
            if(index > -1)
                newArray[index] = action?.payload?.student
            return {
                ...state,
                students: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                users: state?.students?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        case Constants.REMOVE_DOC:
            const student_index = state.students.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.id))            
            const all_students = [...state.students];
            if(student_index > -1){
                const student = all_students[student_index]
                let docs = student?.documents?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.doc_id))
                student['documents'] = docs;
                all_students[student_index] = student
            }
            
            return{
                ...state,
                students: all_students,
                loading: false,
                error: null,
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}